export default __webpack_public_path__ + "static/media/mdf.7f969e2b.jpg";